<template>
  <div
    v-if="isMobileVertical"
    class="footer-wrapper"
    :class="{
      'footer-wrapper--cockfight-dice': showCockfightDice,
      'footer-wrapper--tai-xiu-bar': showTaiXiuBarFooter,
    }"
  >
    <div v-if="showCockfightDice" class="footer-wrapper__dice-slot">
      <DiceLauncher class="footer-wrapper__dice-tab" @click="openTaiXiu" />
    </div>
    <MobileFooterPanel
      :cockfight-active="isCockfightActive"
      @select-cockfight="onSelectCockfight"
    />
  </div>
</template>

<script>
import DiceLauncher from '@/components/tai-xiu/dice-launcher.vue';
import MobileFooterPanel from '@/components/mobile-footer-panel.vue';
import { ROUTE_NAME } from '@/utils/constant';
import { mapActions, mapGetters } from 'vuex';
import { isMobile } from 'mobile-device-detect';

export default {
  components: {
    DiceLauncher,
    MobileFooterPanel,
  },
  computed: {
    ...mapGetters({
      activeProduct: 'taiXiu/activeProduct',
      isTableBarOpen: 'taiXiu/isTableBarOpen',
      quickBetTable: 'taiXiu/quickBetTable',
      taiXiuTables: 'taiXiu/tables',
      isClientV2: 'general/isClientV2',
    }),
    isMobileVertical() {
      return isMobile && this.$screen.width < this.$screen.height;
    },
    showCockfightDice() {
      return (
        this.isClientV2
        // No Tài Xỉu arena (game_type=1 came back empty, or not at all): there
        // is no table bar to open, so no launcher either.
        && this.taiXiuTables.length > 0
        && this.activeProduct === 'cockfight'
        && !this.isTableBarOpen
        && !this.quickBetTable
      );
    },
    showTaiXiuBarFooter() {
      return (
        this.isClientV2
        && (this.isTableBarOpen || this.activeProduct === 'tai-xiu' || !!this.quickBetTable)
      );
    },
    isCockfightActive() {
      // Keyed off the active product, not the footer chrome: the Tài Xỉu table
      // bar now stays open while cockfight is the active product, so its
      // presence no longer means Tài Xỉu has focus. A quick bet sheet still
      // does, even though quick play leaves the product on cockfight.
      if (this.isClientV2) {
        return this.activeProduct === 'cockfight' && !this.quickBetTable;
      }
      if (this.activeProduct === 'cockfight') return true;
      return this.$route.name === ROUTE_NAME.cockFight;
    },
  },
  methods: {
    ...mapActions('taiXiu', ['selectCockfight', 'toggleTableBar']),
    openTaiXiu() {
      this.toggleTableBar();
    },
    onSelectCockfight() {
      if (this.isCockfightActive) return;

      if (this.isClientV2) {
        this.selectCockfight();
        return;
      }

      if (this.$route.name !== ROUTE_NAME.cockFight) {
        this.$router.push({ name: ROUTE_NAME.cockFight });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// v2.1: the footer panel's two rows (38 + 28) and the table bar's 34 on top
// of it make one 100px footer.
$footer-height: 66px;
$table-bar-height: 34px;

.footer-wrapper {
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.footer-wrapper--cockfight-dice {
  padding-top: calc(#{$table-bar-height} + env(safe-area-inset-bottom, 0px));
}

/*
 * The closed dice is the same DiceLauncher the table bar renders, laid out on
 * the same geometry: a 44px band sitting directly on the footer panel, with the
 * launcher 16px in. So opening the bar only swaps the chrome underneath it --
 * the dice itself does not move or resize.
 *
 * That inset is 16px, not 32px: `.feature-table-bar` and `.table-bar` are both
 * classes on the same element, so their paddings override rather than stack.
 */
.footer-wrapper__dice-slot {
  position: absolute;
  left: 0;
  bottom: calc(#{$footer-height} + env(safe-area-inset-bottom, 0px));
  width: 52px;
  height: $table-bar-height;
  border-radius: 12px 12px 0 0;
  background: $ga-rail-bg;
}

.footer-wrapper__dice-tab {
  position: absolute;
  left: 10px;
  top: 0;
  height: $table-bar-height;
}

.footer-wrapper--tai-xiu-bar {
  ::v-deep .mobile-footer-panel {
    border-top: 1px solid $ga-border-default;
    box-shadow: none;
  }
}

@media screen and (max-width: 390px) {
  .footer-wrapper__dice-slot {
    width: 52px;
  }

  .footer-wrapper__dice-tab {
    left: 10px;
  }
}
</style>
